export const navLinks = [
  { id: 'features', label: '平台特色' },
  { id: 'carousel', label: '热点专题' },
  { id: 'faq', label: '常见问题' },
  { id: 'contact', label: '投稿爆料' },
  { id: 'about', label: '关于我们' },
];

export const features = [
  {
    id: 'f1',
    icon: 'ri-flashlight-line',
    title: '一手爆料',
    desc: '全网独家黑料第一时间掌握，专业团队7x24小时持续追踪娱乐圈最新动态，保证你不漏掉任何一个劲爆大瓜。',
  },
  {
    id: 'f2',
    icon: 'ri-shield-check-line',
    title: '真实可靠',
    desc: '每条51吃瓜爆料都经多方交叉核实，拒绝虚假信息和恶意造谣，为你提供最值得信赖的51吃瓜黑料内容。',
  },
  {
    id: 'f3',
    icon: 'ri-group-line',
    title: '吃瓜社区',
    desc: '百万吃瓜群众在线互动，每条51吃瓜今日黑料都有真实网友热评讨论，一起扒皮、一起吃瓜、一起嗨。',
  },
];

export const rankingItems = [
  {
    rank: 1,
    title: '顶流小生深夜密会圈外女友，酒店同框照流出引爆全网',
    heat: '987万',
    tag: '恋情曝光',
    time: '2小时前',
  },
  {
    rank: 2,
    title: '某选秀节目导师被曝天价片酬，节目组内部聊天记录外泄',
    heat: '856万',
    tag: '天价片酬',
    time: '5小时前',
  },
  {
    rank: 3,
    title: '知名女星综艺录制现场情绪失控，导演组紧急暂停拍摄',
    heat: '742万',
    tag: '综艺翻车',
    time: '8小时前',
  },
  {
    rank: 4,
    title: '豪门婚礼内幕曝光，伴手礼清单惊现千万级别珠宝品牌',
    heat: '631万',
    tag: '豪门秘闻',
    time: '12小时前',
  },
  {
    rank: 5,
    title: '某顶流团体成员恋爱实锤，多个粉丝站集体宣布关站脱粉',
    heat: '528万',
    tag: '粉丝脱粉',
    time: '1天前',
  },
];

export const faqItems = [
  {
    q: '51吃瓜官网的内容来源可靠吗？',
    a: '51吃瓜爆料网的所有51吃瓜黑料均来自多渠道交叉核实，我们拥有专业的内容审核团队，确保每条51吃瓜爆料具有可追溯性。同时，51吃瓜官网坚持"有料才爆、有据可查"的原则，拒绝传播未经证实的虚假信息，让每一位吃瓜群众都能放心吃瓜。',
  },
  {
    q: '如何向51吃瓜爆料网投稿？',
    a: '你可以通过本站"投稿爆料"专区提交你的51吃瓜黑料线索。我们支持文字、图片和视频格式投稿，所有投稿均采用匿名保护机制，严格保障爆料人隐私安全。优质爆料一经采用，还将获得丰厚奖励。你的每一条51吃瓜爆料都可能成为下一个全网热搜！',
  },
  {
    q: '51吃瓜黑料网更新频率是多少？',
    a: '51吃瓜官网保持全天候实时更新，我们的编辑团队7x24小时不间断追踪娱乐圈、网红圈、社会热点等领域的51吃瓜今日黑料。平均每天更新超过50条51吃瓜爆料内容，周末和节假日照常运营，确保你永远不会错过任何一个劲爆大瓜。',
  },
  {
    q: '如何在手机上随时吃瓜？',
    a: '51吃瓜官网已全面适配移动端，你只需在手机浏览器中访问本站即可获得流畅的吃瓜体验。此外，我们在页面底部提供了移动端快捷入口，一键添加到手机桌面，即可像使用App一样随时浏览51吃瓜黑料网的最新爆料内容，吃瓜更便捷。',
  },
];

export const comments = [
  {
    id: 'c1',
    user: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20anime%20style%20avatar%20head%20icon%20with%20warm%20orange%20background%2C%20cute%20and%20playful%20expression%2C%20minimalist%20vector%20illustration%20style%2C%20flat%20design&width=80&height=80&seq=avatar-c1&orientation=squarish',
    time: '10分钟前',
    content: '这个瓜我吃了！51吃瓜官网的速度真的没话说，别的平台还在猜来猜去的时候这里已经实锤了，不愧是51吃瓜爆料第一站。每天刷一刷比追剧还过瘾哈哈。',
    likes: 2341,
  },
  {
    id: 'c2',
    user: '娱乐圈考古学家',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20modern%20avatar%20head%20illustration%20with%20warm%20pink%20tone%20background%2C%20trendy%20minimalist%20style%2C%20flat%20vector%20design&width=80&height=80&seq=avatar-c2&orientation=squarish',
    time: '28分钟前',
    content: '我是从微博过来的，发现51吃瓜黑料网的料比微博还快还全，关键是没有那么多水军控评，评论区都是真实路人发言，吃瓜体验满分。已经推荐给身边所有爱吃瓜的朋友了。',
    likes: 1856,
  },
  {
    id: 'c3',
    user: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20avatar%20head%20icon%20with%20mint%20green%20background%2C%20simple%20and%20clean%20flat%20vector%20illustration%2C%20modern%20design&width=80&height=80&seq=avatar-c3&orientation=squarish',
    time: '1小时前',
    content: '51吃瓜今日黑料的质量越来越高了，特别是那个顶流的热搜，图文并茂分析得明明白白。我看完直接把链接转到了好几个微信群，大家都说这个网站太宝藏了。',
    likes: 1532,
  },
  {
    id: 'c4',
    user: '理性吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20avatar%20head%20illustration%20with%20light%20lavender%20background%2C%20clean%20minimalist%20flat%20vector%20design%2C%20modern%20aesthetic&width=80&height=80&seq=avatar-c4&orientation=squarish',
    time: '2小时前',
    content: '说实话之前对这类平台有偏见，但51吃瓜爆料网改变我的看法。每条爆料都有来源标注，评论区也相对理性。希望能一直保持这种高质量，不要像某些平台一样沦为谣言集散地。',
    likes: 1289,
  },
];

export const cards = [
  {
    id: 'card1',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20photography%20with%20warm%20red%20spotlight%20on%20dark%20stage%2C%20microphone%20stand%20silhouette%2C%20cinematic%20moody%20atmosphere%2C%20editorial%20magazine%20style%2C%20high%20contrast%20lighting&width=600&height=400&seq=card-img-01&orientation=landscape',
    title: '某顶流男星机场被拍与神秘女子同行，疑似新恋情',
    excerpt: '近日有网友在机场拍到某当红男星与一神秘女子并肩同行，两人举止亲密疑似新恋情曝光。据知情人士透露，两人已交往数月。',
    tag: '恋情曝光',
    date: '2026-07-29',
    views: '128万',
  },
  {
    id: 'card2',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20award%20ceremony%20stage%20with%20golden%20trophy%20and%20warm%20lighting%2C%20dramatic%20spotlight%20effect%2C%20luxurious%20evening%20atmosphere%2C%20editorial%20photography&width=600&height=400&seq=card-img-02&orientation=landscape',
    title: '知名导演被爆片场苛待演员，多位艺人私下爆料',
    excerpt: '某知名导演再被爆出片场不当行为，多位曾合作过的演员私下向51吃瓜爆料网透露拍摄期间的种种遭遇，业内人士呼吁行业整顿。',
    tag: '业内爆料',
    date: '2026-07-28',
    views: '96万',
  },
  {
    id: 'card3',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20wedding%20venue%20with%20crystal%20chandeliers%20and%20floral%20arrangements%2C%20warm%20golden%20lighting%2C%20romantic%20elegant%20atmosphere%2C%20editorial%20photography%20style&width=600&height=400&seq=card-img-03&orientation=landscape',
    title: '某豪门婚礼细节全曝光，现场布置奢华到令人咋舌',
    excerpt: '备受关注的豪门婚礼终于举办，现场布置奢华程度令人惊叹。据51吃瓜黑料网独家获取的现场细节，整场婚礼耗资超千万。',
    tag: '豪门婚礼',
    date: '2026-07-27',
    views: '215万',
  },
  {
    id: 'card4',
    image: 'https://readdy.ai/api/search-image?query=Music%20studio%20with%20recording%20equipment%20and%20warm%20ambient%20lighting%2C%20creative%20atmosphere%2C%20professional%20audio%20gear%2C%20artistic%20editorial%20photography&width=600&height=400&seq=card-img-04&orientation=landscape',
    title: '当红歌手新专辑被指抄袭，原作者发声要求下架',
    excerpt: '某当红歌手最新专辑主打歌被指抄袭国外小众音乐人作品，原作者已在社交平台公开发声。目前该歌手的经纪团队尚未对此事作出回应。',
    tag: '抄袭争议',
    date: '2026-07-26',
    views: '187万',
  },
  {
    id: 'card5',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20runway%20backstage%20with%20models%20and%20warm%20dressing%20room%20lighting%2C%20glamorous%20atmosphere%2C%20editorial%20fashion%20photography%20style%2C%20luxurious%20texture&width=600&height=400&seq=card-img-05&orientation=landscape',
    title: '某女星红毯造型被嘲，造型师发文怒怼网友',
    excerpt: '某知名女星在最新红毯活动中的造型引发热议，不少网友直言"翻车"。其造型师随后在个人社交账号发文回应，与网友展开激烈交锋。',
    tag: '红毯翻车',
    date: '2026-07-25',
    views: '156万',
  },
  {
    id: 'card6',
    image: 'https://readdy.ai/api/search-image?query=TV%20show%20recording%20set%20with%20cameras%20and%20warm%20studio%20lighting%2C%20behind%20the%20scenes%20atmosphere%2C%20professional%20broadcast%20environment%2C%20editorial%20photography&width=600&height=400&seq=card-img-06&orientation=landscape',
    title: '热门综艺录制现场突发状况，节目组紧急调整赛制',
    excerpt: '某热门综艺最新一期录制现场突发意外状况，导致节目组不得不紧急调整比赛规则。据现场观众爆料，场面一度十分混乱。',
    tag: '综艺事故',
    date: '2026-07-24',
    views: '143万',
  },
];

export const mediaItems = [
  {
    id: 'm1',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20video%20playback%20interface%20with%20play%20button%20overlay%20on%20dark%20cinematic%20scene%2C%20warm%20red%20and%20gold%20accents%2C%20modern%20media%20player%20design%2C%20editorial%20style&width=640&height=360&seq=media-img-01&orientation=landscape',
    title: '独家：某顶流私下聚会视频流出，言行引争议',
    duration: '03:25',
    views: '356万',
  },
  {
    id: 'm2',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20frame%20with%20entertainment%20studio%20scene%20and%20warm%20spotlight%2C%20video%20player%20interface%20element%2C%20dramatic%20moody%20lighting%2C%20modern%20media%20aesthetic&width=640&height=360&seq=media-img-02&orientation=landscape',
    title: '某选秀选手后台痛哭画面曝光，淘汰内幕引猜测',
    duration: '05:12',
    views: '289万',
  },
  {
    id: 'm3',
    image: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20dramatic%20lighting%20and%20crowd%20silhouettes%2C%20video%20overlay%20design%2C%20warm%20golden%20spotlight%20effect%2C%20editorial%20photography&width=640&height=360&seq=media-img-03&orientation=landscape',
    title: '演唱会现场意外：歌手走音被观众集体喊退票',
    duration: '02:48',
    views: '423万',
  },
  {
    id: 'm4',
    image: 'https://readdy.ai/api/search-image?query=Red%20carpet%20event%20with%20celebrities%20and%20camera%20flashes%2C%20video%20player%20frame%20design%2C%20warm%20glamorous%20atmosphere%2C%20editorial%20entertainment%20photography&width=640&height=360&seq=media-img-04&orientation=landscape',
    title: '某颁奖礼现场明星互撕完整视频流出',
    duration: '08:36',
    views: '512万',
  },
];

export const carouselItems = [
  {
    id: 's1',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20collage%20with%20warm%20red%20and%20gold%20lighting%2C%20newspaper%20headline%20aesthetic%2C%20editorial%20magazine%20cover%20style%2C%20high%20contrast%20cinematic%20mood&width=900&height=500&seq=carousel-img-01&orientation=landscape',
    title: '2026上半年娱乐圈十大劲爆事件盘点',
    desc: '从顶流塌房到豪门恩怨，51吃瓜爆料网带你回顾2026上半年最让人瞠目结舌的十大娱乐圈大事件，全程高能。',
    tag: '年度盘点',
    date: '2026-07-28',
  },
  {
    id: 's2',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20celebrity%20wedding%20scene%20with%20floral%20arrangements%20and%20warm%20lighting%2C%20editorial%20magazine%20spread%20style%2C%20glamorous%20atmosphere%2C%20cinematic%20composition&width=900&height=500&seq=carousel-img-02&orientation=landscape',
    title: '深度起底：娱乐圈那些不为人知的"潜规则"',
    desc: '51吃瓜黑料网独家策划，多位圈内人士匿名爆料，揭开娱乐圈光鲜亮丽背后的真实生态。',
    tag: '深度策划',
    date: '2026-07-27',
  },
  {
    id: 's3',
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20cameras%20and%20crew%2C%20warm%20cinematic%20lighting%2C%20editorial%20documentary%20style%20photography%2C%20authentic%20atmosphere&width=900&height=500&seq=carousel-img-03&orientation=landscape',
    title: '选秀节目乱象大起底：从内定到假唱',
    desc: '随着选秀节目热度持续攀升，51吃瓜爆料网跟进调查发现多条选秀产业链黑幕，揭露你所不知道的选秀真相。',
    tag: '行业调查',
    date: '2026-07-26',
  },
  {
    id: 's4',
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20studio%20with%20ring%20light%20and%20camera%20setup%2C%20warm%20modern%20aesthetic%2C%20editorial%20photography%20style%2C%20trendy%20atmosphere&width=900&height=500&seq=carousel-img-04&orientation=landscape',
    title: '网红圈爆火背后的秘密：流量如何被"制造"',
    desc: '从一夜爆红到光速翻车，51吃瓜今日黑料为你揭秘网红经济背后的流量密码与资本运作逻辑。',
    tag: '网红揭秘',
    date: '2026-07-25',
  },
];

export const topics = [
  { id: 't1', name: '顶流塌房', heat: '1287万', color: 'primary' },
  { id: 't2', name: '恋情实锤', heat: '1156万', color: 'accent' },
  { id: 't3', name: '综艺翻车', heat: '1023万', color: 'primary' },
  { id: 't4', name: '豪门秘闻', heat: '987万', color: 'secondary' },
  { id: 't5', name: '抄袭争议', heat: '892万', color: 'accent' },
  { id: 't6', name: '片酬内幕', heat: '756万', color: 'primary' },
  { id: 't7', name: '红毯造型', heat: '689万', color: 'secondary' },
  { id: 't8', name: '网红黑料', heat: '621万', color: 'accent' },
  { id: 't9', name: '粉丝脱粉', heat: '534万', color: 'primary' },
];

export const updates = [
  {
    id: 'u1',
    date: '2026-07-29',
    time: '14:32',
    content: '独家：某男团成员被拍到与经纪人发生激烈争吵，现场视频已由知情人士提交至51吃瓜爆料网，正在核实中。',
    tag: '最新爆料',
  },
  {
    id: 'u2',
    date: '2026-07-29',
    time: '11:15',
    content: '某知名编剧被指新作品涉嫌融梗多部经典作品，网友整理对比图引发热议，51吃瓜黑料网持续关注事件进展。',
    tag: '抄袭争议',
  },
  {
    id: 'u3',
    date: '2026-07-29',
    time: '09:08',
    content: '某女星工作室凌晨发布声明否认隐婚传闻，但声明中多处细节被网友质疑，51吃瓜今日黑料将持续跟进核实。',
    tag: '官方回应',
  },
  {
    id: 'u4',
    date: '2026-07-28',
    time: '22:40',
    content: '某综艺节目录制中导师愤然离场的完整经过曝光，多名现场观众向51吃瓜爆料网提供第一手描述。',
    tag: '综艺爆料',
  },
  {
    id: 'u5',
    date: '2026-07-28',
    time: '18:22',
    content: '某流量小生品牌代言被紧急撤换，知情人士向51吃瓜黑料网透露背后涉及合同纠纷与形象危机。',
    tag: '商务动态',
  },
  {
    id: 'u6',
    date: '2026-07-28',
    time: '15:10',
    content: '某知名导演新片选角内幕曝光，多位演员试镜视频在51吃瓜爆料网社群中广泛流传，引发激烈讨论。',
    tag: '影视内幕',
  },
  {
    id: 'u7',
    date: '2026-07-28',
    time: '10:55',
    content: '某女星被前经纪人实名举报偷税漏税，相关材料已提交相关部门，51吃瓜黑料网将持续追踪事件发展。',
    tag: '重磅爆料',
  },
  {
    id: 'u8',
    date: '2026-07-27',
    time: '20:18',
    content: '某选秀出道团体内部不和视频流出，成员之间疑似发生肢体冲突，51吃瓜爆料网已获取独家现场画面。',
    tag: '团体纠纷',
  },
];

export const indexItems = [
  {
    id: 'idx1',
    title: '明星恋情',
    desc: '最全明星恋情爆料合集',
    count: 128,
    icon: 'ri-heart-line',
  },
  {
    id: 'idx2',
    title: '综艺翻车',
    desc: '综艺节目事故与名场面',
    count: 96,
    icon: 'ri-emotion-laugh-line',
  },
  {
    id: 'idx3',
    title: '豪门恩怨',
    desc: '豪门家族八卦与秘闻',
    count: 74,
    icon: 'ri-vip-crown-line',
  },
  {
    id: 'idx4',
    title: '影视内幕',
    desc: '电影电视剧幕后真相',
    count: 112,
    icon: 'ri-film-line',
  },
  {
    id: 'idx5',
    title: '网红扒皮',
    desc: '网红圈黑料与翻车实录',
    count: 89,
    icon: 'ri-live-line',
  },
  {
    id: 'idx6',
    title: '时尚翻车',
    desc: '明星红毯造型翻车合集',
    count: 67,
    icon: 'ri-t-shirt-line',
  },
  {
    id: 'idx7',
    title: '音乐圈瓜',
    desc: '乐坛抄袭争议与内幕',
    count: 83,
    icon: 'ri-music-line',
  },
  {
    id: 'idx8',
    title: '年度盘点',
    desc: '年度十大劲爆事件回顾',
    count: 45,
    icon: 'ri-calendar-check-line',
  },
];